export enum InterfaceActionType {
  ENTER_FULLSCREEN_MODE = '@@interface/ENTER_FULLSCREEN_MODE',
  EXIT_FULLSCREEN_MODE = '@@interface/EXIT_FULLSCREEN_MODE',
  TOGGLE_SIDENAV = '@@interface/TOGGLE_SIDENAV',
}
